import commonActions from '@/store/data/common/actions'

export default commonActions
